// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"admin","535":"login","601":"insurance","608":"completeInsurance","987":"admins"}[chunkId] || chunkId) + "." + {"328":"ca12d08d","535":"e8dddefe","601":"aa6fa79c","608":"8d38f2d6","641":"9c4447a1","987":"62788cb4"}[chunkId] + ".js";
};